module.exports = __webpack_public_path__ + "img/icon-glosas.a47b49d6.svg";